var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import MediaQuery from 'react-responsive';
import { Dropdown } from 'semantic-ui-react';
import classNames from 'classnames';

import IntExtLinkHandler from './IntExtLinkHandler';
import IntExtHashLinkHandler from './IntExtHashLinkHandler';

var scrollWithOffset = function scrollWithOffset(el) {
  var elementPosition = el.offsetTop - 50;
  window.scroll({
    top: elementPosition,
    left: 0,
    behavior: 'instant'
  });
};

var ManagedMenuDropdown = (_temp2 = _class = function (_React$Component) {
  _inherits(ManagedMenuDropdown, _React$Component);

  function ManagedMenuDropdown() {
    var _temp, _this, _ret;

    _classCallCheck(this, ManagedMenuDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _this.openDropdown = function () {
      _this.setState({
        isOpen: true
      });
    }, _this.closeDropdown = function () {
      _this.setState({
        isOpen: false
      });
    }, _this.onNavLinkClick = function (event, data) {
      event.stopPropagation();
      _this.closeDropdown();
    }, _this.onDropdownClick = function () {
      var history = _this.props.history;

      _this.closeDropdown();
      history.push(_this.props.menuItem.url);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // this needs passed in from props to stay with the current pattern
  // and avoid too much refactoring


  ManagedMenuDropdown.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        pathname = _props.pathname,
        menuItem = _props.menuItem,
        history = _props.history,
        child = _props.child,
        mobileBreakpoint = _props.mobileBreakpoint;
    var isOpen = this.state.isOpen;

    var dropdownClassName = classNames({
      'nav-menu__dropdown': child === false,
      'nav-menu__dropdown--link': child,
      'nav-menu__dropdown--active': pathname.lastIndexOf(menuItem.url, 0) === 0
    });
    return React.createElement(
      React.Fragment,
      null,
      React.createElement(
        MediaQuery,
        { minWidth: mobileBreakpoint },
        React.createElement(
          Dropdown,
          {
            item: true,
            className: dropdownClassName,
            open: isOpen,
            onMouseEnter: this.openDropdown,
            onMouseLeave: this.closeDropdown,
            onClick: this.onDropdownClick,
            text: menuItem.title
          },
          React.createElement(
            Dropdown.Menu,
            { onClick: function onClick(e, d) {
                return e.stopPropagation();
              } },
            menuItem.children && menuItem.children.map(function (menuChildItem, key) {
              return React.createElement(
                Dropdown.Item,
                { key: 'menuChildItem_' + key },
                menuChildItem.children ? React.createElement(ManagedMenuDropdown, {
                  menuItem: menuChildItem,
                  pathname: pathname,
                  history: history,
                  child: true,
                  mobileBreakpoint: mobileBreakpoint
                }) : menuChildItem.url.includes('#') ? React.createElement(IntExtHashLinkHandler, {
                  menuItem: menuChildItem,
                  onNavLinkClick: _this2.onNavLinkClick,
                  scrollWithOffset: scrollWithOffset,
                  linkClassName: 'nav-menu__nav-link ' + (menuChildItem.parent && menuChildItem.parent > 0 ? 'nav-menu__nav-link-child' : '')
                }) : React.createElement(IntExtLinkHandler, { menuItem: menuChildItem })
              );
            })
          )
        )
      ),
      React.createElement(
        MediaQuery,
        { maxWidth: mobileBreakpoint - 1 },
        React.createElement(IntExtLinkHandler, { menuItem: menuItem }),
        menuItem.children && menuItem.children.map(function (menuChildItem, key) {
          return menuChildItem.children ? React.createElement(ManagedMenuDropdown, {
            menuItem: menuChildItem,
            pathname: pathname,
            history: history,
            child: true,
            mobileBreakpoint: mobileBreakpoint
          }) : menuChildItem.url.includes('#') ? React.createElement(IntExtHashLinkHandler, {
            menuItem: menuChildItem,
            onNavLinkClick: _this2.onNavLinkClick,
            scrollWithOffset: scrollWithOffset,
            linkClassName: 'nav-menu__nav-link ' + (menuChildItem.parent && menuChildItem.parent > 0 ? 'nav-menu__nav-link-child' : '')
          }) : React.createElement(IntExtLinkHandler, { menuItem: menuChildItem });
        })
      )
    );
  };

  return ManagedMenuDropdown;
}(React.Component), _class.defaultProps = {
  child: false
}, _temp2);


export default ManagedMenuDropdown;